import { useAlert } from 'react-alert';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';
import I18n from 'i18n-js';

import { useDeal } from '@lootboy/lib/slices/deals/hooks';

import Alert from '~/components/Alert';
import { CardPopupContainer } from '~/components/molecules/CardPopupContainer';

import { useClosePopup } from '~/hooks/useClosePopup';
import { parseLootBoyError } from '~/utilities/errors';
import { FetchedDealsContent } from '~/views/DealsView/FetchedDealsContent';

import { ReactComponent as Spinner } from '~/assets/images/iconsLibrary/loading-spinner.svg';

import styles from './DealsView.module.scss';

export default function DealsView(): JSX.Element {
  const alert = useAlert();
  const closePopup = useClosePopup();
  const { dealId } = useParams<{ dealId: string }>();

  const deal = useDeal(dealId, (error) => {
    const { message } = parseLootBoyError(error);

    alert.error(
      <Alert
        title={I18n.t('common_error')}
        body={message}
      />,
    );
    closePopup();
  });

  return (
    <CardPopupContainer
      onClose={closePopup}
      className={classNames(styles.popup, !deal && styles.loading)}
    >
      {!deal ? (
        <Spinner className={styles.spinner} />
      ) : (
        <FetchedDealsContent
          deal={deal}
          onClose={closePopup}
        />
      )}
    </CardPopupContainer>
  );
}
